(function () {
  function setInputToDefaultQty(input) {
    if (!input) return;

    const d = parseInt(input.dataset.defaultQty || '1', 10);
    if (!Number.isFinite(d) || d <= 1) return;

    // Toujours forcer la valeur à la quantité custom (même si le thème reset)
    input.value = String(d);
    input.setAttribute('value', String(d));

    // Prévenir le composant / scripts du thème
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function applyDefaultQty(root) {
    const scope = root || document;
    scope.querySelectorAll('input.quantity__input[data-default-qty]').forEach(setInputToDefaultQty);
  }

  // ✅ Sleek: quand la page + assets sont prêts
  document.addEventListener('page:loaded', function () {
    applyDefaultQty(document);
  });

  // ✅ Sleek: après ajout au panier AJAX
  document.addEventListener('product-ajax:added', function () {
    // Sleek peut re-render juste après → on re-force plusieurs fois
    setTimeout(() => applyDefaultQty(document), 0);
    setTimeout(() => applyDefaultQty(document), 150);
    setTimeout(() => applyDefaultQty(document), 400);
    setTimeout(() => applyDefaultQty(document), 900);
  });

  // ✅ Sleek: après mise à jour du panier (markup updated)
  document.addEventListener('cart:updated', function () {
    setTimeout(() => applyDefaultQty(document), 0);
    setTimeout(() => applyDefaultQty(document), 150);
  });

  // ✅ Sleek: quick view lazy-loaded
  document.addEventListener('quick-view:loaded', function (evt) {
    applyDefaultQty(document);
  });

  // ✅ Sleek: changement de variante (souvent reset qty)
  document.addEventListener('variant:changed', function () {
    setTimeout(() => applyDefaultQty(document), 0);
  });

  // Fallback au cas où (si page:loaded n'est pas dispatch)
  document.addEventListener('DOMContentLoaded', function () {
    applyDefaultQty(document);
  });
})();
